import { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { verificationErrorsSelector, verificationStatusSelector } from './selectors'
import {
  VERIFICATION_AWAITING,
  VERIFICATION_REQUESTING_CODE,
  VERIFICATION_RESENDING_CODE,
  createPhoneNumber,
  clearPhoneNumberErrors
} from './slice'
import { SMSVerificationInput } from './sms_verification_input'

export const SMSVerification = ({ phoneNumber, ownerId }) => {
  const dispatch = useDispatch()
  const fieldStatus = useSelector(verificationStatusSelector)
  const { verification: verificationErrors } = useSelector(verificationErrorsSelector)

  const [isVerificationCodeSent, setVerificationCodeSent] = useState(false)
  const [verificationCode, setVerificationCode] = useState('')

  const isErrorsEmpty = !verificationErrors

  const resetCodeError = useCallback(() => {
    if (isErrorsEmpty) return

    dispatch(clearPhoneNumberErrors())
  }, [dispatch, isErrorsEmpty])


  const onVerificationCodeChange = (value, isFilled) => {
    resetCodeError()
    setVerificationCode(value)
    if (isFilled && !isVerificationCodeSent) {
      setVerificationCodeSent(true)

      dispatch(createPhoneNumber({ userId: ownerId, phoneNumber, verificationCode: value }))
    } else {
      setVerificationCodeSent(false)
    }
  }

  useEffect(() => {
    if (fieldStatus !== VERIFICATION_REQUESTING_CODE && fieldStatus !== VERIFICATION_RESENDING_CODE) { return }

    setVerificationCode('')
  }, [fieldStatus])

  if (fieldStatus !== VERIFICATION_AWAITING && fieldStatus !== VERIFICATION_RESENDING_CODE) {
    return null
  }

  return (
    <SMSVerificationInput
      value={verificationCode}
      onFocus={resetCodeError}
      onChange={onVerificationCodeChange}
      error={verificationErrors}
    />
  )
}
